import { useTranslation } from "react-i18next";

// السطر التفصيلي حسب نوع الإشعار.
export const NotificationLine = ({ item }) => {
  const { t, i18n } = useTranslation();
  const data = item.data;
  if (!data) return null;
  if (item.type === "platform_broadcast") {
    const ar = (i18n.language || "ar").startsWith("ar");
    return (
      <p className="mt-1 text-xs font-semibold text-muted-foreground" data-testid="notification-broadcast-line">
        {(ar ? data.body_ar || data.body_en : data.body_en || data.body_ar) || data.body}
      </p>
    );
  }
  if (item.type.startsWith("penalty_") || item.type.startsWith("bonus_")) {
    const message = i18n.language === "en" ? data.message_en : data.message_ar;
    return (
      <p className="mt-1 text-xs font-semibold text-muted-foreground" data-testid="notification-penalty-line">
        {message || data.message_ar}
      </p>
    );
  }
  if (item.type === "daily_attendance_summary") {
    return (
      <p className="mt-1 text-xs font-semibold text-muted-foreground" data-testid="notification-digest-line">
        {t("notifications.digest", {
          branch: data.branch_name,
          present: data.present?.length ?? 0,
          late: data.late?.length ?? 0,
          absent: data.absent?.length ?? 0,
        })}
      </p>
    );
  }
  if (item.type === "absence_warning") {
    return (
      <p className="mt-1 text-xs font-semibold text-danger" data-testid="notification-absence-warning-line">
        {t(`notifications.absenceWarning.${data.reason}`, { minutes: data.minutes })}
      </p>
    );
  }
  if (item.type === "day_absences") {
    return (
      <p className="mt-1 text-xs font-semibold text-danger" data-testid="notification-absences-line">
        {t("notifications.dayAbsences", { count: data.count, name: data.name })}
      </p>
    );
  }
  if (item.type === "document_expiry") {
    return (
      <p className="mt-1 text-xs font-semibold text-warning" data-testid="notification-doc-expiry-line">
        {t(data.days_left < 0 ? "notifications.docExpired" : "notifications.docExpiry", {
          count: data.count,
          name: data.name,
          days: Math.abs(data.days_left),
        })}
      </p>
    );
  }
  return null;
};
